import { useQuery } from '../../../hooks';
import { FivetranConnectionCacheKeys } from '../consts';

import * as connectionsService from '../service';

export const useFivetranConnections = (customerId?: string) => {
  const getFivetranConnections = useQuery({
    queryFn: async () => connectionsService.getFivetranConnections(customerId),
    queryKey: [FivetranConnectionCacheKeys.GetConnections, customerId],
  });

  return {
    getFivetranConnections,
  };
};
